import {textToHtml} from '@frontapp/editor-html';
import React, {FC} from 'react';

import {AsyncHandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {EmailFormatsEnum} from '../../../../helpers/models/emailFormatHelpers';
import {AnswerModel} from '../../../../models/api/answerModel';
import {MessageVisualTypesEnum} from '../../../../models/api/messageModel';
import {AnswerDialogValues} from './answerDialogBase';
import {AnswerDialogContainerProps} from './answerDialogContainer';
import {HtmlAnswerDialog} from './htmlAnswerDialog';
import {MarkdownAnswerDialog} from './markdownAnswerDialog';

/*
 * Props.
 */

interface AnswerDialogProps extends AnswerDialogContainerProps {
  onCreateClick: AsyncHandlerOf<AnswerDialogValues, AnswerModel>;
}

/*
 * Component.
 */

export const AnswerDialog: FC<AnswerDialogProps> = (props) => {
  const {message, ...otherProps} = props;

  /*
   * Render.
   */

  if (message.format === EmailFormatsEnum.MARKDOWN) {
    return <MarkdownAnswerDialog {...otherProps} key={message.uid} initialText={message.text} />;
  }

  if (message.visualType === MessageVisualTypesEnum.EMAIL) {
    return <HtmlAnswerDialog {...otherProps} key={message.uid} initialCleanHtml={message.html} />;
  }

  return <HtmlAnswerDialog {...otherProps} key={message.uid} initialCleanHtml={textToHtml(message.text)} />;
};
